import Link from "next/link";

import { Column } from "@/components/containers";
import { CheckCircleIcon } from "@/components/icons";
import { ButtonRound } from "@/components/inputs";

import { ChargePointResult } from "./ChargePointResult";

export interface PosaChargeCompleteProps {
  currentPoints: number;
}

export function PosaChargeComplete({ currentPoints }: PosaChargeCompleteProps) {
  return (
    <Column align="center" gap={20}>
      <Column className="my-[20px]" align="center" gap={10}>
        <CheckCircleIcon />
        <p className="text-center whitespace-pre-wrap text-[20px] font-bold text-message-ok">{`ポイントのチャージが\n完了しました`}</p>
      </Column>

      <ChargePointResult currentPoints={currentPoints} />

      <p className="text-center text-[12px]">
        ポイントを利用するには、マイページにて「すべてのポイントを利用する」にチェックを入れてください。
      </p>

      <p className="text-center text-[12px]">
        詳しくは
        <a
          href="https://basefood.zendesk.com/hc/ja/articles/6923114970393-%E3%83%9D%E3%82%A4%E3%83%B3%E3%83%88%E3%83%91%E3%83%83%E3%82%AF%E3%81%AF%E3%81%A9%E3%81%AE%E3%82%88%E3%81%86%E3%81%AB%E5%88%A9%E7%94%A8%E3%81%A7%E3%81%8D%E3%81%BE%E3%81%99%E3%81%8B#h_01G3ZF7H4JXXDJTWSQTYS0SY2X"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary"
        >
          ヘルプページ
        </a>
        をご覧ください。
      </p>

      <Link href="/mypage">
        <ButtonRound label="マイページに戻る" />
      </Link>
    </Column>
  );
}
